/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Filter1Inputs */

const en_columnmenu_filter1 = /** @type {(inputs: Columnmenu_Filter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const de_columnmenu_filter1 = /** @type {(inputs: Columnmenu_Filter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtern`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Columnmenu_Filter1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_filter1 = /** @type {((inputs?: Columnmenu_Filter1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Filter1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_filter1(inputs)
	return de_columnmenu_filter1(inputs)
});
export { columnmenu_filter1 as "columnMenu_filter" }